export default "/assets/site/images/termeszet.jpg?455985657430de2d65edcd8256171bc8";